import React from "react"
import SubBlogPostsWrapperStyle from "./SubBlogPostsWrapperStyle.module.styl"

const SubBlogPostsWrapper = ({ children }) => {
  return <div className={SubBlogPostsWrapperStyle.wrapper}>{children}</div>
}

export default SubBlogPostsWrapper
